module.exports = __webpack_public_path__ + "img/bg_ques_header.0b04991b.png";